import { render, staticRenderFns } from "./AlunosReposicao.vue?vue&type=template&id=3fbd42ff&scoped=true"
import script from "./AlunosReposicao.vue?vue&type=script&lang=js"
export * from "./AlunosReposicao.vue?vue&type=script&lang=js"
import style0 from "./AlunosReposicao.vue?vue&type=style&index=0&id=3fbd42ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd42ff",
  null
  
)

export default component.exports